<template>
    <span v-if="status" class="d-inline-flex">
        <b-badge :variant="status.variant"
                 pill
                 class="v-status-badge d-inline-flex align-items-center"
                 v-b-tooltip.noninteractive.hover.bottom
                 :title="status.label">
            <span class="material-icons-round v-status-badge-icon">{{ status.icon }}</span>
        </b-badge>
    </span>
    <span v-else class="text-muted">-</span>
</template>

<script>
import { BBadge, VBTooltip } from 'bootstrap-vue'

// Backend: Domain/BaseDb/Enums/PaymentPoolStatus.cs
export const PAYMENT_POOL_STATUS = {
    0: { icon:'hourglass_top',      variant:'warning', label:'Yönetici taksit onayı bekleniyor' },
    1: { icon:'block',              variant:'danger',  label:'Yönetici onayı ile iptal edildi' },
    2: { icon:'hourglass_disabled', variant:'danger',  label:'Yönetici yanıt vermediği için zaman aşımına uğradı' },
    3: { icon:'send',               variant:'info',    label:'Müşteriye gönderildi' },
    4: { icon:'hourglass_disabled', variant:'danger',  label:'Müşteri ödeme yapmadığı için zaman aşımına uğradı' },
    5: { icon:'pie_chart',     variant:'primary',   label:'Ödeme işlemi parçalı şekilde tamamlandı' },
    6: { icon:'check_circle',  variant:'success',   label:'Ödeme işlemi tamamlandı' },
    7: { icon:'add_circle',    variant:'success',   label:'Fatura toplam tutarından fazla ödeme yapıldı' },
    8: { icon:'percent',       variant:'dark',      label:'Komisyon ödemesi' },
}

export default {
    components:{ BBadge },
    directives:{ 'b-tooltip':VBTooltip },
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        status(){
            const raw = this.row?.PaymentPoolStatus
            if(raw === null || raw === undefined || raw === '') return null
            const code = Number(raw)
            // Yalnızca tamamen kapanmış (kalan borç kalmamış) faturada "müşteri ödemedi / zaman aşımı" (4) bilgisi anlamsız → gösterme
            if(code === 4 && !(Number(this.row?.KalanBorc) > 0)) return null
            return PAYMENT_POOL_STATUS[code] || null
        }
    }
}
</script>

<style>
.v-status-badge{
    padding: 0.25rem;
    line-height: 1;
}
.v-status-badge-icon{
    font-size: 0.95rem;
}
</style>
